import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './FolderBar';
import { AppState } from '../../../../../types/store';
import {
  unsetSelectedFolderId,
  pauseCurrentFolderDeviationFetching,
} from '../../../../actions/gallectionSection';
import { getFolderById } from '../../../../selectors/folders';
import {
  getCurrentlyViewedFolderId,
  getGallectionSectionType,
} from '../../../../selectors/gallectionSection';

export type StateProps = Pick<Props, 'currentlyViewedFolder'>;
export type DispatchProps = Pick<
  Props,
  'unsetSelectedFolderId' | 'pauseCurrentFolderDeviationFetching'
>;
export type OwnProps = Without<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const currentlyViewedFolderId = getCurrentlyViewedFolderId(state);
  return {
    currentlyViewedFolder:
      currentlyViewedFolderId &&
      getFolderById(
        state,
        getGallectionSectionType(state),
        currentlyViewedFolderId
      ),
  };
};
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  unsetSelectedFolderId,
  pauseCurrentFolderDeviationFetching,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
